import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import './UserInfoModal.css';

const UserInfoModal = () => {
    const { saveUserInfo } = useAuth();
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [errors, setErrors] = useState({});

    const validateForm = () => {
        const newErrors = {};
        
        if (!name.trim()) {
            newErrors.name = 'Name is required';
        }
        
        if (!email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(email)) {
            newErrors.email = 'Email is invalid';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (validateForm()) {
            saveUserInfo(name, email);
        }
    };

    return (
        <div className="user-info-modal-overlay">
            <div className="user-info-modal">
                <div className="modal-header">
                    <h2>Welcome to Aditi Textile!</h2>
                    <p>Please tell us about yourself</p>
                </div>

                <form onSubmit={handleSubmit} className="user-info-form">
                    <div className="form-group">
                        <label>Your Name *</label>
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Enter your name"
                            className={errors.name ? 'error' : ''}
                        />
                        {errors.name && <span className="error-text">{errors.name}</span>}
                    </div>

                    <div className="form-group">
                        <label>Email Address *</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className={errors.email ? 'error' : ''}
                        />
                        {errors.email && <span className="error-text">{errors.email}</span>}
                    </div>

                    <button type="submit" className="submit-btn">
                        Continue Shopping
                    </button>
                </form>

                <p className="privacy-note">
                    We'll use this information to personalize your shopping experience
                </p>
            </div>
        </div>
    );
};

export default UserInfoModal;
